// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"2e4b9f42","262":"973f1c1c"}[chunkId] + ".chunk.css";
};